import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryIndex from "../pages/category/page";
import CategoryDetail from "../pages/category/[slug]/page";
import ComicDetail from "../pages/comic/[slug]/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <CategoryIndex />,
  },
  {
    path: "/category/:slug",
    element: <CategoryDetail />,
  },
  {
    path: "/comic/:slug",
    element: <ComicDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;